import each from 'lodash/each';
import get from 'lodash/get';

import NODE_TYPES from 'src/models/Ivrs/NodeTypes';
import { Point } from 'src/presentation/components/pages/ivr/components/ivrTree/ivrTypes';
import { TreeLayoutNodeTypeEnum } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';
import { wrapLabel } from 'src/presentation/components/pages/shared/utils/textUtils';

const TREE_LABEL_MAX_WIDTH = 120;

type ConnectingPoints = {
  left?: Point[];
  right?: Point[];
  top?: Point[];
  bottom?: Point[];
};

class TreeNode {
  private node: any = null;

  private _connectionPoints: ConnectingPoints = {};
  private _description: string[];
  private _height: number;
  private _id: string;
  private _name: string[];
  private _nodeType: TreeLayoutNodeTypeEnum;
  private _parentNode: TreeNode;
  private _ref: string;
  private _type: NODE_TYPES;
  private _width: number;
  private _x: number;
  private _y: number;
  private _selection: string[];

  constructor(node) {
    this.node = node;
    this._description = wrapLabel(node.ivrNode?.description || '', TREE_LABEL_MAX_WIDTH, 'bold 10px Inter');
    this._height = node.height;
    this._id = node.id;
    this._name = wrapLabel(node.name, TREE_LABEL_MAX_WIDTH, 'bold 10px Inter');
    this._nodeType = node.nodeType ? node.nodeType : TreeLayoutNodeTypeEnum.NODE;
    this._selection = wrapLabel(node.ivrNode?.selection || '', TREE_LABEL_MAX_WIDTH, 'bold 10px Inter');
    this._type = node.type;
    this._width = node.width;
    this._x = node.x;
    this._y = node.y;
    this.setParentNodeForChildren();
  }

  get ivrNode() {
    return get(this.node, 'ivrNode');
  }

  get description() {
    return this._description;
  }

  get selection() {
    return this._selection;
  }

  get connectionPoints() {
    return this._connectionPoints;
  }

  set connectionPoints(value) {
    this._connectionPoints = value;
  }

  get name() {
    return this._name;
  }

  get bottom(): Point {
    return [this._x + this._width / 2, this._y + this._height];
  }

  get top(): Point {
    return [this._x + this._width / 2, this._y];
  }

  get left(): Point {
    return [this._x, this._y + this._height / 2];
  }

  get right(): Point {
    return [this._x + this._width, this._y + this._height / 2];
  }

  get x() {
    return this._x;
  }

  set x(x) {
    this._x = x;
  }

  get y() {
    return this._y;
  }

  set y(y) {
    this._y = y;
  }

  get type() {
    return this._type;
  }

  get nodeType() {
    return this._nodeType;
  }

  get width() {
    return this._width;
  }

  get height() {
    return this._height;
  }

  get id() {
    return this._id;
  }

  get parentNode() {
    return this._parentNode;
  }

  get ref() {
    return this._ref;
  }

  private setParentNodeForChildren() {
    if (this.node.children) {
      each(this.node.children, (childNode: TreeNode) => {
        childNode._parentNode = this.node;
      });
    }
  }
}

export default TreeNode;
